(function() {
  'use strict';

  let size;
  let mix_tl;
  let rawSize;
  let backBtn;
  let nextBtn;
  let dryUnit;
  let doseUnit;
  let result_tl;
  let restartBtn;
  let dryMedUnit;
  let totalDoses;
  let unitsPerDose;
  let liquidAmount;
  let vialCapacity;
  const lReg = /[a-zA-Z]/g;

  let _u = {
    d: document,
    findNode: (s, t) => s.querySelector(t),
    getNode: (s) => _u.d.querySelector(s),
    getNodes: (s) => _u.d.querySelectorAll(s),
    getIndex: (s) => [...s.parentNode.children].indexOf(s),
  };

  let _a = {
    init: () => {
      _a.initEls();
      _a.initVars();
      _a.initProps();
      _a.updateSyringeSize();
      _a.attachEvents();
    },
    initEls: () => {
      backBtn = _u.getNode('.pc-back');
      nextBtn = _u.getNode('.pc-next');
      doseUnit = _u.getNode('#doseUnit');
      dryMedUnit = _u.getNode('#dryMedUnit');
      liquidAmount = _u.getNode('#liquidAmount');
      
    },
    initVars: () => {
      dryUnit = 'g';
      mix_tl = gsap.timeline({
        default: {
          duration: 0.5,
          clearProps: "all",
          ease: "circ.inOut"
        }
      });
      result_tl = gsap.timeline({
        default: {
          duration: 0.5,
          clearProps: "all",
          ease: "circ.inOut"
        }
      });
    },
    initProps: () => {
      gsap.set('.contents', { width: 50 });
      gsap.set('.phase:not(.active), #dry_medication', { opacity: 0, autoAlpha: 0 });
      gsap.set(".pc-restart", { display: "none" })
      gsap.set("#mixed_medication", { scaleY: 0, transformOrigin: "50% 100%" })
    },
    attachEvents: () => {
      nextBtn.addEventListener('click', _a.moveToNextPhase, false);
      backBtn.addEventListener('click', _a.moveToPrevPhase, false);

      const syringeSizeOptionEls = _u.getNodes('#syringe_size_slider label');
      syringeSizeOptionEls.forEach((el, _) => el.addEventListener('click', _a.updateSyringeSize, false));

      dryMedUnit.addEventListener('change', _a.updateDryUnit, false);
      doseUnit.addEventListener('change', _a.updateDoseUnit, false);

      liquidAmount.addEventListener('keyup', _a.liquidAmountChanged), true;

      const desiredDose = document.getElementById("desiredDose");
      desiredDose.addEventListener('keyup', _a.desiredDoseChanged), true;

      const dryMed = document.getElementById("dryMed");
      dryMed.addEventListener('keyup', _a.dryMedChanged), true;
    },
    restart: () => {
      _a.resetAnimation();
      _a.resetFields();
      _a.resetPhase();
      _a.resetBtns();
    },
    resetAnimation: () => {
      mix_tl.time(0).kill();
      result_tl.time(0).kill();
      _a.initVars();
      gsap.to("#dry_medication", { duration: 0.125, opacity: 0, autoAlpha: 0, ease: "power1.in" })
      gsap.to("#mixed_medication", { duration: 0.125, scaleY: 0, ease: "power1.in" })
    },
    resetFields: () => {
      const dryMed = _u.getNode('#dryMed');
      const dryMedUnit = _u.getNode('#dryMedUnit');
      const liquidAmount = _u.getNode('#liquidAmount');
      const desiredDose = _u.getNode('#desiredDose');
      const doseUnit = _u.getNode('#doseUnit');

      dryMed.value = 1;
      dryMedUnit.value = "mg";
      liquidAmount.value = 0.25;
      desiredDose.value = 250;
      doseUnit.value = "mg";

    },
    resetPhase: () => {
      gsap.set('.phase.active', { duration: 0.125, opacity: 0, autoAlpha: 0, ease: "power1.in" })
      gsap.set('.phase:nth-child(1)', { duration: 0.125, opacity: 1, autoAlpha: 1, ease: "power1.out" })

      _u.getNode('.phase.active').classList.remove('active');
      _u.getNode('.phase:nth-child(1)').classList.add('active');
    },
    resetBtns: () => {
      gsap.set('.pc-back, .pc-next', { display: "block" });
      gsap.set('.pc-restart', { display: "none" });
      _u.getNode('.pc-next').textContent = 'Next';
      _u.getNode('.pc-back').classList.add('disabled');
    },
    calculateVialCapacity: () => {
      return rawSize * 1.5;
    },
    liquidAmountChanged: (e) => {
      liquidAmount = _u.getNode('#liquidAmount');

      const value = parseFloat(liquidAmount.value);

      // validate

    //  liquidAmount.value = value > vialCapacity
    //  ? rawSize
    //  : (lReg.test(liquidAmount.value)) ? ''
    //  : value;

    },
    desiredDoseChanged: () => {
      const desiredDose = document.getElementById("desiredDose");
      const value = desiredDose.value;

      desiredDose.value = (lReg.test(value)) ? '' : value
    },
    dryMedChanged: () => {
      const dryMed = document.getElementById("dryMed");
      const value = dryMed.value;

      dryMed.value = (lReg.test(value)) ? '' : value
    },
    updateDryUnit: (e) => {
      const target = e.target;
      dryUnit = target.value;
    },
    updateDoseUnit: (e) => {
      const target = e.target;
      doseUnit = target.value;
    },
    moveToNextPhase: () => {
      const index = _u.getIndex(_u.getNode('.phase.active'));
      const nextIndex = index + 1;

      console.log(nextIndex)

      if (nextIndex > _u.getNodes('.phase').length - 1) {
        // disable the next button
        nextBtn.classList.remove('disabled');
        return
      };

      if (nextIndex > 0 && backBtn.classList.contains('disabled')) {
        backBtn.classList.remove('disabled');
      }

      if (nextIndex === 1) {
        gsap.to("#dry_medication", { duration: 0.25, opacity: 1, autoAlpha: 1, ease: "power1.out" })
      }

      if (nextIndex === 2) {
      }

      if (nextIndex === 3) {
        _a.mixTl()
      }

      if (nextIndex === 4) {
        const ratio = unitsPerDose / (rawSize * 100);

        if (ratio > 1 || ratio < 0) {
          return
        }

        gsap.set(".pc-back, .pc-next", { display: "none" });
        gsap.set(".pc-restart", { display: "flex" });
        restartBtn = _u.getNode('.pc-restart');
        restartBtn.addEventListener('click', _a.restart, false);

        _a.calculateResults();
        _a.resultTl();
      }

      gsap.to('.phase.active', { duration: 0.125, opacity: 0, autoAlpha: 0, ease: "power1.in" })
      gsap.to('.phase.active + .phase', { delay: 0.125, duration: 0.125, opacity: 1, autoAlpha: 1, ease: "power1.out" })

      _u.getNode('.phase.active + .phase').classList.add('active')
      _u.getNode('.phase.active').classList.remove('active')
    },
    mixTl: () => {
      const liquidAmount = parseFloat(document.getElementById("liquidAmount").value);
      const ratio = liquidAmount / rawSize;

      mix_tl
        .addLabel("bact_IN")
        .to(".syringe.active", { x: -100, rotation: 90, transformOrigin: "50% 50%", onStart: () => {
          backBtn.classList.add('disabled');
          nextBtn.classList.add('disabled');
        } }, "bact_IN")
        .to(".syringe.active", { y: rawSize === 1 ? 70 : rawSize === 2 ? 124 : rawSize === 3 ? 105 : rawSize === 0.5 ? 110 : 112 }, "-=0.25")

        .addLabel("extract_IN")
        .to(".syringe.active .plunger", { duration: 1, x: () =>
          -parseFloat(_u.getNode(".syringe.active .contents rect").getAttribute("width")) * ratio
         }, "extract_IN")
        .to(".syringe.active .contents", { duration: 1, scaleX: ratio, transformOrigin: "100% 50%" }, "extract_IN")
        .to(".syringe.active .padd", { duration: 0.025, opacity: 1, autoAlpha: 1 }, "extract_IN")
        .to("#bact_water", { duration: 1, scaleY: Math.max(0, 1 - (liquidAmount / vialCapacity)), transformOrigin: "50% 100%" }, "extract_IN")

        .addLabel("to_vial")
        .to(".syringe.active", { y: -50 }, "to_vial")
        .to(".syringe.active", { x: 90, transformOrigin: "50% 50%" }, "-=0.125")
        .to(".syringe.active", { y: rawSize === 1 ? 70 : rawSize === 2 ? 124 : rawSize === 3 ? 105 : rawSize === 0.5 ? 110 : 112 }, "-=0.25")

        .addLabel("discharge")
        .to(".syringe.active .plunger", { x: 0 }, "discharge-=0.05" )
        .to(".syringe.active .contents", { scaleX: 0, transformOrigin: "100% 50%" }, "discharge-=0.05")
        .to("#mixed_medication", { scaleY: Math.min(liquidAmount / vialCapacity, 1), transformOrigin: "50%, 100%", ease: "power1.out" }, "discharge-=0.05")
        .to(".syringe.active .padd", { duration: 0.025, opacity: 0, autoAlpha: 0 })

        .addLabel("back_to_init")
        .to(".syringe.active", { y: 0 }, "back_to_init")
        .to(".syringe.active", { x: 0, rotation: 0, transformOrigin: "50% 50%"})

        .addLabel("swirl")
        .to("#medication_vial", { duration: 0.125, rotation: -5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: 5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: -5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: 5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: -5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: 5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.25, rotation: -5.5, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#medication_vial", { duration: 0.125, rotation: 0, transformOrigin: "50% 20%", ease: "circ.inOut" })
        .to("#mixed_medication", { duration: 1.75, scaleY: Math.min(liquidAmount / vialCapacity, 1), transformOrigin: "50% 100%", fill: "#08ffff", onComplete: () => {
          nextBtn.textContent = 'Calculate';
          backBtn.classList.remove('disabled');
          nextBtn.classList.remove('disabled');
        } }, "swirl").pause();

        mix_tl.resume();
    },
    resultTl: () => {
      const liquidAmount = parseFloat(document.getElementById("liquidAmount").value);

      let ratio = unitsPerDose / (rawSize * 100);

      result_tl
        .addLabel("to_vial")
        .to(".syringe.active", { x: 90, rotation: 90, transformOrigin: "50% 50%" }, "-=0.125")
        .to(".syringe.active", { y: rawSize === 1 ? 70 : rawSize === 2 ? 124 : rawSize === 3 ? 105 : rawSize === 0.5 ? 110 : 112 }, "-=0.25")

        .addLabel("extract_IN")
        .to(".syringe.active .plunger", { duration: 1, x: () =>
          -parseFloat(_u.getNode(".syringe.active .contents rect").getAttribute("width")) * ratio
         }, "extract_IN")
        .to(".syringe.active .contents", { duration: 1, scaleX: ratio, transformOrigin: "100% 50%" }, "extract_IN")
        .to(".syringe.active .padd", { duration: 0.025, opacity: 1, autoAlpha: 1 }, "extract_IN")

        .addLabel("vial_reduction", "extract_IN")
        .to("#mixed_medication", { duration: 1, scaleY: ((liquidAmount / vialCapacity) + 0.15) - (((liquidAmount / vialCapacity) + 0.15) / totalDoses) }, "vial_reduction")

        .addLabel("back_to_init")
        .to(".syringe.active", { y: 0 }, "back_to_init")
        .to(".syringe.active", { x: 0, rotation: 0, transformOrigin: "50% 50%"})


    },
    moveToPrevPhase: () => {
      const index = _u.getIndex(_u.getNode('.phase.active'));
      const prevIndex = index - 1;

      console.log(prevIndex)

      if (prevIndex === 0) {
        backBtn.classList.add('disabled')
        gsap.to("#dry_medication", { duration: 0.125, opacity: 0, autoAlpha: 0, ease: "power1.in" })
      }

      if (prevIndex === 2) {
        mix_tl.time(0).kill();
        mix_tl = gsap.timeline({
          default: {
            duration: 0.5,
            clearProps: "all",
            ease: "circ.inOut"
          }
        });
      }

      gsap.to('.phase.active', { duration: 0.125, opacity: 0, autoAlpha: 0, ease: "power1.in" })
      gsap.to(`.phase:nth-child(${prevIndex + 1})`, { delay: 0.125, duration: 0.125, opacity: 1, autoAlpha: 1, ease: "power1.out" })

      _u.getNode('.phase.active').classList.remove('active')
      _u.getNode(`.phase:nth-child(${prevIndex + 1})`).classList.add('active')
    },
    hideSyringe: (e) => {
      gsap.to(e, { duration: 0.125, y: -20, opacity: 0, autoAlpha: 0, ease: "power1.in" });
      _u.getNode(e).classList.remove('active')
    },
    showSyringe: (e) => {
      gsap.fromTo(e, { y: 20, opacity: 0, autoAlpha: 0, ease: "power1.out", onComplete:
        () => e.classList.add('active') }, {
          y: 0, opacity: 1, autoAlpha: 1, delay: 0.125, duration: 0.25,
        });
    },
    updateSyringeSize: (e) => {
      const defaultSizeInputEl = _u.getNode('#syringe_size_slider input:checked');
      const target = e ? e.target : defaultSizeInputEl.nextElementSibling;
      size = `s${target.dataset.syringeSize.replace('.', '_')}`;
      rawSize = parseFloat(target.dataset.syringeSize);
      vialCapacity = _a.calculateVialCapacity();
      const selectedSyringe = _u.getNode(`#${size}`);

      if (target === selectedSyringe) return;
      _u.getNode('.syringe.active') && _a.hideSyringe(".syringe.active");
      _a.showSyringe(selectedSyringe);

      liquidAmount.placeholder = `0-${target.dataset.syringeSize}`.replace('ml', '')
    },
    convertToSelectedUnit: (value, unit) => {
      if (unit === "mg") return value * 1000;
      if (unit === "g") return value * 1000000;
      return value;
    },
   calculateResults: () => {
  const dryMed = parseFloat(document.getElementById("dryMed").value);
  const liquidAmount = parseFloat(document.getElementById("liquidAmount").value); // mL
  const desiredDose = parseFloat(document.getElementById("desiredDose").value);

  // Get unit selections
  const dryMedUnit = document.getElementById("dryMedUnit").value; // 'mcg', 'mg', 'g'
  const doseUnit = document.getElementById("doseUnit").value;     // 'mcg', 'mg', 'g'

  // Convert both to **mcg**
  const dryMedInMcg = (dryMedUnit === "mg") ? dryMed * 1000 :
                      (dryMedUnit === "g")  ? dryMed * 1000000 :
                      dryMed; // already mcg

  const desiredDoseInMcg = (doseUnit === "mg") ? desiredDose * 1000 :
                           (doseUnit === "g")  ? desiredDose * 1000000 :
                           desiredDose; // already mcg

  // Total doses = total med / desired dose
  totalDoses = (dryMedInMcg / desiredDoseInMcg).toFixed(2);

  // Units per dose = (desiredDose / totalMed) * total liquid volume * 100 (for insulin syringes)
  unitsPerDose = ((desiredDoseInMcg / dryMedInMcg) * liquidAmount * 100).toFixed(2);

  // Display
  document.getElementById("unitsPerDose").innerText = `${unitsPerDose}`;
  document.getElementById("totalDoses").innerText = `${totalDoses}`;
	   
	   
	   console.log("---- Debugging Calculation ----");
console.log("DryMed Input:", document.getElementById("dryMed").value, document.getElementById("dryMedUnit").value);
console.log("DesiredDose Input:", document.getElementById("desiredDose").value, document.getElementById("doseUnit").value);
console.log("LiquidAmount Input:", document.getElementById("liquidAmount").value);

console.log("Converted DryMedInMcg:", dryMedInMcg);
console.log("Converted DesiredDoseInMcg:", desiredDoseInMcg);
console.log("Calculated Total Doses:", totalDoses);
console.log("Calculated Units per Dose:", unitsPerDose);
console.log("--------------------------------");
}

  };
  _a.init();
})();